export default [
  {
    path: '/health',
    meta: {
      title: '健康'
    },
    component: () => import('Pages/health'),
  },
  {
    path: '/health/home',
    component: () => import('Pages/health/home')
  },
  {
    path: '/doc-publish-page',
    component: () => import('Pages/health/doc-publish-page')
  },
  {
    path: '/doc-publish-search',
    component: () => import('Pages/health/doc-publish-search')
  }
]



// WEBPACK FOOTER //
// ./src/router/health.js